import { getGraphQLErrorCode } from '@data-access/lib/execute'

const CART_CURRENCY_MISMATCH = 'CART_CURRENCY_MISMATCH'

export const isCartCurrencyMismatchError = (error: unknown) =>
  getGraphQLErrorCode(error) === CART_CURRENCY_MISMATCH
